import { createAction } from '@reduxjs/toolkit';
import { type BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import type { BoundaryLocationsFilter } from '../toolsState/boundary/mapSettingsToolsStateBoundary.state';
import {
  MAP_SETTINGS_BOUNDARIES_SET_ISOLATE_COLOR,
  MAP_SETTINGS_BOUNDARIES_SET_PRIMARY_BOUNDARY_GROUP_ID,
} from './mapSettingsBoundaries.actionTypes';

export const mapSettingsBoundaryGroupOrderUpdated = createAction(
  'MAP_SETTINGS_BOUNDARY_ORDER_UPDATED',
  (boundaryGroupOrder: BoundaryGroupId[]) => ({
    payload: {
      boundaryGroupOrder,
    },
  }),
);
export const mapSettingsBoundaryGroupOrderGroupHoisted = createAction(
  'MAP_SETTINGS_BOUNDARY_ORDER_GROUP_HOISTED',
  (boundaryGroupId: BoundaryGroupId) => ({
    payload: {
      boundaryGroupId,
    },
  }),
);

export const mapSettingsBoundariesSetPrimaryBoundaryGroupId = (primaryBoundaryGroupId: BoundaryGroupId | null) => ({
  type: MAP_SETTINGS_BOUNDARIES_SET_PRIMARY_BOUNDARY_GROUP_ID,
  payload: {
    primaryBoundaryGroupId,
  },
}) as const;

export const mapSettingsBoundariesSetIsolateColor = (color: string) => ({
  type: MAP_SETTINGS_BOUNDARIES_SET_ISOLATE_COLOR,
  payload: {
    color,
  },
}) as const;

export const mapSettingsBoundariesSetIsolatedBoundaries = createAction(
  'MAP_SETTINGS_BOUNDARIES_SET_ISOLATED_BOUNDARIES',
  (boundaryGroupId: BoundaryGroupId, isolatedBoundariesFilter: BoundaryLocationsFilter) => ({
    payload: {
      boundaryGroupId,
      isolatedBoundariesFilter,
    },
  })
);

export const mapSettingsBoundariesClearIsolatedBoundaries = createAction(
  'MAP_SETTINGS_BOUNDARIES_CLEAR_ISOLATED_BOUNDARIES',
  () => ({
    payload: {},
  })
);
